import React, { useState } from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import SideMenu from './SideMenu/SideMenu';
import './Navigation.css';

const Navigation = () => {
  const { isAuthenticated, logout, currentUser } = useAuth();
  const { darkMode, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  
  // Log the dark mode state for debugging
  console.log("Navigation darkMode:", darkMode);
  console.log("Document has dark-theme class:", document.documentElement.classList.contains('dark-theme'));

  const toggleMenu = () => {
    setMenuOpen(prevState => !prevState);
    console.log("Menu toggled:", !menuOpen);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <SideMenu isOpen={menuOpen} toggleMenu={toggleMenu} darkMode={darkMode} />
      <Navbar bg={darkMode ? "dark" : "light"} variant={darkMode ? "dark" : "light"} expand="lg" className="mb-4">
        <Container>
          <Button
            variant={darkMode ? "dark" : "light"}
            className="me-2 hamburger-btn"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className="fs-4">☰</span>
          </Button>
          <Navbar.Brand as={Link} to="/">
            StoryCape
          </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {isAuthenticated && (
              <>
                <Nav.Link as={Link} to="/stories">Stories</Nav.Link>
                {/*<Nav.Link as={Link} to="/create-story">Create New Story</Nav.Link>*/}
                <Nav.Link as={Link} to="/apps">Manage Apps</Nav.Link>
                <Nav.Link as={Link} to="/analytics">Analytics</Nav.Link>
              </>
            )}
          </Nav>
          <Nav>
            <Button
              variant={darkMode ? "outline-light" : "outline-dark"}
              onClick={toggleTheme}
              className="me-3"
              aria-label="Toggle theme"
            >
              {darkMode ? '☀️ Light' : '🌙 Dark'}
            </Button>
            {isAuthenticated ? (
              <div className="d-flex align-items-center">
                {currentUser && (
                  <span className={`me-3 ${darkMode ? 'text-light' : 'text-dark'}`}>
                    Welcome, {currentUser.email}
                  </span>
                )}
                <Button variant={darkMode ? "danger" : "danger"} onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            ) : (
              <Nav.Link as={Link} to="/login">Login</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
};

export default Navigation;